import React from "react";
import { Select, SelectProps } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleSelectProps extends SelectProps {
  useEditorTheme?: boolean;
}

const TrebbleSelect: React.FC<TrebbleSelectProps> = ({ useEditorTheme = false, ...restProps }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <ConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Select {...restProps} />
    </ConfigProvider>
  );
};

export default TrebbleSelect; 